import React from 'react';
import { Dialog } from './Dialog';
import LoginForm from './LoginForm';

import './LoginButton.scss';
import { LoginStatus, logout, UserRole } from '../data/sessionSlice';
import { connect } from 'react-redux';
import { State } from '../data/rootReducer';
import { AppConnectedProps } from '../data/store';

const connector = connect((state: State) => ({ session: state.session }));

interface LoginButtonProps extends AppConnectedProps<typeof connector> {
  className?: string;
}

class LoginButton extends React.Component<LoginButtonProps> {
  state = {
    showDialog: false,
  };

  static getDerivedStateFromProps(props: LoginButtonProps, state: { showDialog: boolean }) {
    // Dismiss dialog after login.
    if (state.showDialog && props.session.loginStatus === LoginStatus.LOGGED_IN) {
      return { showDialog: false };
    }
    return null;
  }

  render() {
    return this.props.session.userRole !== UserRole.Viewer ? (
      this.renderLogoutButton()
    ) : (
      <>
        {this.renderLoginButton()}
        {this.state.showDialog ? (
          <Dialog onDialogCancel={() => this.setState({ showDialog: false })}>
            <LoginForm />
          </Dialog>
        ) : (
          ''
        )}
      </>
    );
  }

  renderLoginButton() {
    return (
      <button
        className={'login-button ' + this.props.className}
        onClick={() => this.setState({ showDialog: true })}
      >
        Login
      </button>
    );
  }

  renderLogoutButton() {
    return (
      <button
        className={'logout-button ' + this.props.className}
        onClick={() => this.props.dispatch(logout())}
      >
        Logout
      </button>
    );
  }
}

export default connector(LoginButton);
